let headerFlag        = false;
let stHeader  = document.getElementById('st-Header');
let stHeaderNav  = document.getElementById('st-Header_Nav');
let stHeaderBg  = document.getElementById('st-Header_Bg');
let headerButton  = document.getElementById('st-Menu');

const $modal = $('#sw-Youtube');
const $content = $('#sw-Youtube_Content');


// var windowW       = $(window).width();
// var windowH       = $(window).innerHeight();
// var _isSP         = false;
// var _isipad  = false;



// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{


  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    // headerFlag        = false;
    // stHeaderNav.classList.remove('opened');
    // headerButton.classList.remove('opened');
    // stHeaderBg.classList.remove('opened');
    // stHeaderLogo.classList.remove('opened');
    // stHeaderNav.classList.add('closed');
    // headerButton.classList.add('closed');
    // stHeaderBg.classList.add('closed');
    // stHeaderLogo.classList.add('closed');

    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};

// ------------------------------------------------------------------------
// toggleHeader
// ----- BOTH
// ------------------------------------------------------------------------
const toggleHeader = () => {


  headerButton.addEventListener('click', () => {

    if(!headerFlag){
      // $('#st-Header_Navi').css({'display':'block'});
      setTimeout(function(){
        stHeader.classList.remove('closed');
        stHeaderNav.classList.remove('closed');
        headerButton.classList.remove('closed');
        stHeaderBg.classList.remove('closed');
        stHeader.classList.add('opened');
        stHeaderNav.classList.add('opened');
        headerButton.classList.add('opened');
        stHeaderBg.classList.add('opened');
        headerFlag = true;
      },0);
    }else{
      stHeader.classList.remove('opened');
      stHeaderNav.classList.remove('opened');
      headerButton.classList.remove('opened');
      stHeaderBg.classList.remove('opened');
      stHeader.classList.add('closed');
      stHeaderNav.classList.add('closed');
      headerButton.classList.add('closed');
      stHeaderBg.classList.add('closed');
      headerFlag = false;
      // setTimeout(function(){
      //   // $('#st-Header_Navi').css({'display':'none'});
  		// },0);
    }
  }, false);

};


// ------------------------------------------------------------------------
// pageTop
// ----- BOTH
// ------------------------------------------------------------------------
const pageTop = () => {

  $("#st-Top").on("click", function(){
    var linkSpeed    = 800;
    $("html, body").animate({scrollTop: 0}, linkSpeed, "easeOutExpo");
    return false;
  });
};



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {

  //ページ外からのページ内リンク
  var urlHash = location.hash;
  if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
          var target = $(urlHash);
          var position = target.offset().top - 80;
          $('body,html').stop().animate({scrollTop:position}, 500);
      }, 200);
  }

  var linkSpeed    = 1000;
  var linkAdjust   = 20;

  //ページ内リンク
  $("a[href^='#']").on("click", function(){

    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;

    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "easeInOutQuint");
    return false;
  });

};

// ------------------------------------------------------------------------
// showMovie
// ----- BOTH
// ------------------------------------------------------------------------
const showMovie = () => {

  // open
  $('.js-Youtube').on('click', function(){

    const dataID = $(this).attr('data-youtube');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},500,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;
    });
  });


  //close
  $('#sw-Youtube_Close,#sw-Youtube_Content ').on('click', function(){

    $('#sw-Youtube').css({'opacity':'1'}).stop().animate({'opacity':'0'},500,'easeOutQuart',function(){
      $('#sw-Youtube').css({'display':'none'});
      $content.children().remove();
		});
  });

};

// ------------------------------------------------------------------------
// showImg
// ----- BOTH
// ------------------------------------------------------------------------
const showImg = () => {

  // open
  $('.js-Img').on('click', function(){

    const dataID = $(this).attr('data-img');

    $('#sw-Youtube').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},500,'easeOutQuart',function(){


      //img append
      $content.append('<img src="'+dataID+'">');
      // fadeIn
      $modal.stop().fadeIn(400);
      return false;

    });
  });

  //close
};

// ------------------------------------------------------------------------
// divideCharacter
// ----- BOTH
// ------------------------------------------------------------------------
const divideCharacter = () => {

  const textbox = document.querySelectorAll('.divide-character');
  const textboxArray = Array.prototype.slice.call(textbox); //Array


  textboxArray.forEach(textbox => {
    let text = textbox.textContent;
    textbox.innerHTML = null;

    text.split('').forEach(function (c) {
      textbox.innerHTML += '<span class="letter"><span class="letter-inner">'+c+'</span></span>';
    });
  });
};


// mouseStalker
// ----- BOTH
// ------------------------------------------------------------------------
const mouseStalker = () => {

  //マウスストーカー用のdivを取得
  const stalker = document.getElementById('sw-Stalker');

  //aタグにホバー中かどうかの判別フラグ
  let hovFlag = false;

  //マウスに追従させる処理 （リンクに吸い付いてる時は除外する）
  document.addEventListener('mousemove', function (e) {
      // if (!hovFlag) {
      stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
      // }
  });

  //リンクへ吸い付く処理
  const linkElem = document.querySelectorAll('a:not(.no_stick_)');
  for (let i = 0; i < linkElem.length; i++) {
      //マウスホバー時
      linkElem[i].addEventListener('mouseover', function (e) {
          hovFlag = true;

          //マウスストーカーにクラスをつける
          stalker.classList.add('hover');

          //マウスストーカーの位置をリンクの中心に固定
          // let rect = e.target.getBoundingClientRect();
          // let posX = rect.left + (rect.width / 2);
          // let posY = rect.top + (rect.height / 2);

          // stalker.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';

      });
      //マウスホバー解除時
      linkElem[i].addEventListener('mouseout', function (e) {
          hovFlag = false;
          stalker.classList.remove('hover');
      });
  }

};



export {
  preload,
  pageTop,
  anchorLink,
  toggleHeader,
  showMovie,
  showImg,
  divideCharacter,
  mouseStalker
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js